module.exports = __webpack_public_path__ + "media/images/front/icon_mypage-b889066ec0dae80c9a6ab87efaa90dfd.png";